<script>
import productGroupComponent from '@/components/table_product_group/table_product_group.vue';

export default {
  data() {
    return {
      filters: {
        search: '',
      },
      rights: ['admin', 'worker'],
      placeholder_text: 'Search by asin, product title, worker comment, client comment',
    };
  },
  computed: {
    utilized() {
      return this.$store.state.utilized.utilized;
    },
    loaded() {
      return this.$store.state.utilized.loaded;
    },
    chosen_client() {
      return this.$store.state.users.chosen_client;
    },
    app_section() {
      return this.$store.getters.get_app_section;
    },
    filteredUtilized() {
      if (this.utilized.length === 0) return [];

      return this.utilized.filter((group) => {
        const asin = (group.filter(
          (product) => product.asin.toLowerCase().includes(this.filters.search.toLowerCase()),
        )).length > 0;

        const productTitle = (group.filter(
          (product) => product.title.toLowerCase().includes(this.filters.search.toLowerCase()),
        )).length > 0;

        const workerComment = (group.filter((product) => {
          if (product.worker_comment === null) return false;

          return product.worker_comment.toLowerCase().includes(this.filters.search.toLowerCase());
        })).length > 0;

        const clientComment = (group.filter((product) => {
          if (product.client_comment === null) return false;

          return product.client_comment.toLowerCase().includes(this.filters.search.toLowerCase());
        })).length > 0;

        return asin || productTitle || workerComment || clientComment;
      });
    },
  },
  created() {
    this.$store.dispatch('utset_loaded', false);

    this.$store.dispatch('ututilized_list');
    if (this.rights.indexOf(this.user_role) !== -1 && !this.chosen_client) {
      this.$router.push({ name: `${this.app_section}-clients` });
    }
  },
  components: {
    product_group_component: productGroupComponent,
  },
  methods: {
    set_search(str) {
      this.filters.search = str;
    },
  },
};
</script>
<template src="./utilized.pug" lang="pug"></template>
